import { render, staticRenderFns } from "./CenterCategoryForm.vue?vue&type=template&id=6bd9de4e&scoped=true"
import script from "./CenterCategoryForm.vue?vue&type=script&lang=js"
export * from "./CenterCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd9de4e",
  null
  
)

export default component.exports